import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Submission } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_ALL_SUBMISSION_FOR_PATIENT_CONTENT_ID_KEY =
  'get-all-submission-for-patient-content-id';

export const useGetAllSubmissionByContentIdAndDate = (contentId: number) => {
  return usePermittedQuery<Submission[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/submission/content/${contentId}`,
    {},
    [GET_ALL_SUBMISSION_FOR_PATIENT_CONTENT_ID_KEY],
    {
      enabled: typeof contentId === 'number' && contentId > 0,
      refetchOnWindowFocus: false,
    },
  );
};
